// components/Payroll.js
import React, { useState } from 'react';

const StaffPayroll = () => {
  const [view, setView] = useState('list'); // 'list' or 'preview'
  
  const payrollData = [
    { date: '28 Dec 2024', status: 'Present', amount: '0.0' },
    { date: '27 Dec 2024', status: 'Absent', amount: '' },
    { date: '26 Dec 2024', status: 'Present', amount: '0.0' },
    { date: '25 Dec 2024', status: 'Present', amount: '0.0' },
    { date: '24 Dec 2024', status: 'Present', amount: '0.0' },
  ];

  if (view === 'preview') {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Payroll Preview</h1>
        
        <div className="bg-white border rounded-lg p-4 mb-4">
          <div className="text-center mb-4">
            <h2 className="text-xl font-bold">Stellaris</h2>
            <p className="text-gray-600">John DoE</p>
            <p className="text-gray-500">23 May 2024 - 23 May 2024</p>
          </div>
          
          <div className="border-t pt-4">
            <div className="flex justify-between mb-2">
              <span>30 Days Salary</span>
              <span>$25.99</span>
            </div>
            <div className="flex justify-between font-bold border-t pt-2">
              <span>Total</span>
              <span>$25.99</span>
            </div>
          </div>
        </div>
        
        <button className="w-full bg-primary text-white py-3 rounded-lg font-semibold">
          Download
        </button>
        
        <button 
          onClick={() => setView('list')}
          className="w-full bg-gray-200 text-gray-800 py-2 rounded-lg mt-2"
        >
          Back to List
        </button>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">My Payroll</h1>
      
      {/* Employee Info */}
      <div className="mb-6">
        <h2 className="text-lg font-semibold">John DoE</h2>
        
        <div className="flex justify-between mt-2">
          <div className="flex-1 mr-2">
            <label className="block text-gray-500 text-sm mb-1">Start Date</label>
            <div className="border rounded p-2">00-00-0000</div>
          </div>
          <div className="flex-1 ml-2">
            <label className="block text-gray-500 text-sm mb-1">End Date</label>
            <div className="border rounded p-2">00-00-0000</div>
          </div>
        </div>
      </div>

      {/* Payroll List */}
      <div className="space-y-3 mb-6">
        {payrollData.map((item, index) => (
          <div key={index} className="border rounded-lg p-3">
            <div className="flex justify-between items-center">
              <span className="font-medium">{item.date}</span>
              <span className={`px-3 py-1 rounded-full text-sm ${item.status === 'Present' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {item.status}
              </span>
            </div>
            {item.amount && <div className="mt-2 text-right font-semibold">${item.amount}</div>}
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="bg-blue-50 rounded-lg p-4 mb-4">
        <div className="flex justify-between mb-2">
          <span>Base Salary (3 Days)</span>
          <span>$0.00</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>+ Additions</span>
          <span>$0.00</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>- Deductions</span>
          <span>$0.00</span>
        </div>
        <div className="flex justify-between font-bold border-t pt-2">
          <span>Total</span>
          <span>$0.00</span>
        </div>
      </div>

      <div className="text-center">
        <button 
          onClick={() => setView('preview')}
          className="w-full bg-primary text-white py-3 rounded-lg font-semibold mb-2"
        >
          Generate Salary Slip
        </button>
        <button className="w-full bg-green-500 text-white py-2 rounded-lg">
          + Add Salary
        </button>
      </div>
    </div>
  );
};

export default StaffPayroll;